import { DataTable, TableFooter } from 'bold-ui'
import { CpfOrCns } from 'components/CpfOrCns'
import { TableBox } from 'components/table'
import { usePagination } from 'components/table/usePagination'
import { css } from 'emotion'
import type { Cidadao } from 'graphql/types.generated'
import React from 'react'

import { IdadeCidadaoGrupos } from './IdadeCidadaoGrupos'

type CidadaoRow = Pick<Cidadao, 'id' | 'nome' | 'nomeSocial' | 'cpf' | 'cns' | 'dataNascimento' | 'sexo'>

interface CidadaoTableProps {
  items: CidadaoRow[]
}

export const CidadaoTable = (props: CidadaoTableProps) => {
  const { items } = props
  const { paginatedItems, tableProps } = usePagination({ items, initialPageSize: 5 })

  return (
    <TableBox>
      <DataTable<CidadaoRow>
        rows={paginatedItems}
        columns={[
          {
            name: 'nome',
            header: 'Nome',
            render: (row) => row.nome?.titleCase() ?? row.nomeSocial?.titleCase() ?? '-',
            style: styles.tableRowCommon,
          },
          {
            name: 'cpfCns',
            header: 'CPF ou CNS',
            render: (row) => <CpfOrCns cpf={row.cpf} cns={row.cns} />,
          },
          {
            name: 'dataNascimento',
            header: 'Data de nasc.',
            render: (row) => <IdadeCidadaoGrupos dataNascimento={row.dataNascimento} />,
            style: styles.tableRowDataNascimento,
          },
          {
            name: 'sexo',
            header: 'Sexo',
            render: (row) => row.sexo?.titleCase() ?? '-',
            style: styles.tableRowCommon,
          },
        ]}
      />
      <TableFooter style={styles.tableFooter} {...tableProps} />
    </TableBox>
  )
}

const styles = {
  tableFooter: css`
    border-top: 0;
  `,
  tableRowCommon: css`
    width: 20rem;
    line-height: 1.5rem;
  `,
  tableRowDataNascimento: css`
    width: 12rem;
    line-height: 1.5rem;
  `,
  tableRowButtons: css`
    width: 3.5rem;
    text-align: right;
  `,
}
